import { API_ENDPOINTS } from '../../config/api-config';
import { eventBus } from '../event-bus';

let bannerPageCache: { allowed: boolean; matchedStyle: string | null };

export const isBannerPage = async () => {
  try {
    if (!bannerPageCache) {
      const response = await fetch(API_ENDPOINTS.PAGE_CONFIG);
      const data = await response.json();

      const currentURL = window.location.href;
      let matchedStyle = null;
      let allowed = false;

      if (data && data.bannerPageURls) {
        const allUrlsArray = Object.keys(data.bannerPageURls);
        allUrlsArray.forEach((url) => {
          if (currentURL.includes(url)) {
            matchedStyle = data.bannerPageURls[url];
            allowed = true;
          }
        });
        bannerPageCache = { allowed, matchedStyle };
        return { allowed, matchedStyle };
      }

      return { allowed: false, matchedStyle: null };
    }
    return bannerPageCache;
  } catch (error) {
    console.error('Error checking banner page config:', error);
    return { allowed: false, matchedStyle: null };
  }
};

export const updatePPAGInlineButton = (buttonText: string, disabled: boolean, matchedStyle?: string) => {
  console.info('###UPDATE PPAG');

  const chatbuttons = document.querySelectorAll('#start-chat-button');

  chatbuttons.forEach((button) => {
    (button as HTMLAnchorElement)?.removeAttribute('href');
    if (!disabled) {
      (button as HTMLAnchorElement).onclick = () => {
        eventBus.dispatch('onCAButtonClicked', {});
      };
    } else {
      (button as HTMLAnchorElement).onclick = () => {
        console.info('PPAG  button disabled');
      };
    }

    (button as HTMLAnchorElement).innerHTML = ` <img
      src="${
        disabled
          ? `${API_ENDPOINTS.CLOUDINARY_BASE_URL}/fl_sanitize,q_auto/help_center/chat-icon-disabled.svg`
          : matchedStyle === 'white'
            ? `${API_ENDPOINTS.CLOUDINARY_BASE_URL}/fl_sanitize,q_auto/help_center/chat-icon-black.svg`
            : `${API_ENDPOINTS.CLOUDINARY_BASE_URL}/fl_sanitize,q_auto/help_center/chat-icon-white.svg`
      }"
      alt="image"
      class="swan-icon swan-icon-mask swan-icon-size-standard swan-icon-skin-standard swan-icon-type-image caHelpIconBg"
      id="caButtonIcon"
    />${buttonText}`;

    if (matchedStyle === 'black' && !disabled) {
      (button as HTMLAnchorElement).style.backgroundColor = '#000000';
      (button as HTMLAnchorElement).style.borderColor = '#000000';
      (button as HTMLAnchorElement).style.color = '#ffffff';
    }
    if (matchedStyle === 'white' && !disabled) {
      (button as HTMLAnchorElement).style.backgroundColor = '#ffffff';
      (button as HTMLAnchorElement).style.borderColor = '#ffffff';
      (button as HTMLAnchorElement).style.color = '#000000';
    }
    if (disabled) {
      (button as HTMLAnchorElement).style.backgroundColor = '#dfdfdf';
      (button as HTMLAnchorElement).style.borderColor = '#dfdfdf';
      (button as HTMLAnchorElement).style.color = '#9e9e9e';
    }
  });
};
